export const WALLET_TRANSACTIONLOG_LIST_REQUEST = 'WALLET_TRANSACTIONLOG_LIST_REQUEST';

export const WALLET_TRANSACTIONLOG_LIST = 'WALLET_TRANSACTIONLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_WALLET_TRANSACTIONLOG_PAGINATION = 'SET_WALLET_TRANSACTIONLOG_PAGINATION';

export const WALLET_TRANSACTIONLOG_PAGE_RESET = 'WALLET_TRANSACTIONLOG_PAGE_RESET';
